import { Modal, Button, Tag, Alert } from "antd";
 

const EventModal = ({
  isVisible,
  selectedEvent,
  onClose,
  onAccept,
  onReject,
  fromAttendTab,
}) => {
  if (!selectedEvent) return null;

  const userResponse = selectedEvent.user_response;
  console.log(userResponse);

  const slotsLeft =
    selectedEvent.max_participants - selectedEvent.registered_users_count;

  const formatToDateOnly = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const today = new Date();
  const todayDateOnly = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const eventEnd = formatToDateOnly(selectedEvent.end_date);

  const isEventExpired = eventEnd < todayDateOnly;

  const isSlotsFull =
    selectedEvent.access_type?.toLowerCase() === "limited" && slotsLeft <= 0;

  const computedStatus = isEventExpired
    ? "closed"
    : isSlotsFull
    ? "closed"
    : selectedEvent.access_type?.toLowerCase() === "Open"
    ? "open"
    : selectedEvent.status?.toLowerCase();

  return (
    <Modal
      title={null}
      open={isVisible}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <div style={{ marginLeft: "10px", marginRight: "18px" }}>
        {/* Header */}
        <div
          style={{
           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "24px 32px",
            color: "white",
            borderRadius: "8px",
            marginRight: "2px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              margin: 0,
              color: "white",
              fontSize: "22px",
              fontWeight: 600,
              marginBottom: 8,
            }}
          >
            {selectedEvent.eventTopic}
          </h2>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              opacity: 0.95,
            }}
          >
            <span style={{ fontSize: "16px", fontWeight: 600 }}>Trainer:</span>
            <span style={{ fontSize: "15px" }}>{selectedEvent.trainer}</span>

            <Tag
              color="green"
              style={{
                margin: 0,
                fontSize: "14px",
                padding: "4px 5px",
                borderRadius: "6px",
                fontWeight: 500,
              }}
            >
              {selectedEvent.type.toUpperCase()}
            </Tag>
          </div>
        </div>

        {/* Content */}
        <div style={{ padding: "20px 10px" }}>
          {selectedEvent.mandatory ? (
            <Alert
              message="⚠️ This is a Mandatory Event"
              type="warning"
              style={{ marginBottom: 15, borderRadius: 8 }}
            />
          ) : userResponse === null && (
            <Alert
              message="⏳ Please accept or reject this event."
              type="warning"
              style={{ marginBottom: 15, borderRadius: 8 }}
            />
          )}

          {/* Schedule */}
          <div
            style={{
              background: "#f6f8fc",
              borderRadius: 12,
              padding: "18px",
              marginBottom: 20,
              border: "1px solid #e8ecf3",
            }}
          >
            <div
              style={{
                color: "#8c8c8c",
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: 4,
                fontWeight: 600,
              }}
            >
              Schedule
            </div>

            <div
              style={{
                fontSize: "15px",
                color: "#262626",
                lineHeight: 1.8,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <strong>Start:</strong> {selectedEvent.start_date}
                </div>
                <div>
                  <strong>End:</strong> {selectedEvent.end_date}
                </div>
                <div>
                  <strong>Time:</strong> {selectedEvent.timing}
                </div>
              </div>
            </div>

            {selectedEvent.type === "ilt" && (
              <div style={{ marginTop: 12 }}>
                <span style={{ fontWeight: 600 }}>Location: </span>
                <span style={{ color: "#1677ff", fontWeight: 500 }}>
                  {selectedEvent.location}
                </span>
              </div>
            )}

            {selectedEvent.type === "virtual" && (
              <div style={{ marginTop: 12 }}>
                <span style={{ fontWeight: 600 }}>Meeting Link: </span>
                <a
                  href={selectedEvent.link}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    color: "#1677ff",
                    textDecoration: "underline",
                    fontWeight: 500,
                  }}
                >
                  Join Virtual Event
                </a>
              </div>
            )}

            {selectedEvent.type === "e-learning" && (
              <div style={{ marginTop: 12 }}>
                <span style={{ fontWeight: 600 }}>Course Name: </span>
                <span style={{ color: "#1677ff", fontWeight: 500 }}>
                  {selectedEvent.course_name}
                </span>
              </div>
            )}
          </div>

          {/* Participants + Access */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
              marginBottom: 20,
            }}
          >
            {selectedEvent.access_type?.toLowerCase() === "limited" ? (
              <div
                style={{
                  background: "#fafafa",
                  padding: "14px 18px",
                  borderRadius: 8,
                  border: "1px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    color: "#8c8c8c",
                    marginBottom: 6,
                    fontWeight: 600,
                  }}
                >
                  PARTICIPANTS
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#262626",
                  }}
                >
                  <span>
                    {selectedEvent.min_participants} -{" "}
                    {selectedEvent.max_participants}
                  </span>
                  <span
                    style={{
                      background: "#edf5ffff",
                      color: "#1677ff",
                      fontSize: "13px",
                      fontWeight: 600,
                      padding: "3px 10px",
                      borderRadius: 6,
                      border: "1px solid #86baebff",
                    }}
                  >
                    {slotsLeft > 0 ? `${slotsLeft} Slots Left` : "Full"}
                  </span>
                </div>
              </div>
            ) : (
              <div
                style={{
                  background: "#fafafa",
                  padding: "14px 18px",
                  borderRadius: 8,
                  border: "1px solid #f0f0f0",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    color: "#8c8c8c",
                    marginBottom: 6,
                    fontWeight: 600,
                  }}
                >
                  PARTICIPANTS
                </div>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: 500,
                  }}
                >
                  Open to All
                </div>
              </div>
            )}

            {/* Status */}
            <div
              style={{
                background: "#fafafa",
                padding: "14px 18px",
                borderRadius: 8,
                border: "1px solid #f0f0f0",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  color: "#8c8c8c",
                  marginBottom: 4,
                  fontWeight: 600,
                }}
              >
                STATUS
              </div>
              <Tag
                color={
                  computedStatus === "open"
                    ? "green"
                    : computedStatus === "scheduled"
                    ? "green"
                    : computedStatus === "closed"
                    ? "red"
                    : "orange"
                }
                style={{ margin: 0 }}
              >
                {computedStatus.toUpperCase()}
              </Tag>
            </div>
          </div>

          {/* Buttons */}
          {!fromAttendTab && !selectedEvent.mandatory && (
            <div style={{ display: "flex", gap: "12px", paddingTop: 8 }}>
              {userResponse === true ? (
                // Show single "Accepted" button
                <Button
                  type="primary"
                  size="large"
                  style={{
                    flex: 1,
                    height: 44,
                    borderRadius: 8,
                    fontWeight: 500,
                    background: "#52c41a",
                    border: "none",
                    cursor: "default",
                  }}
                >
                  Accepted
                </Button>
              ) : userResponse === false ? (
                // Show single "Rejected" button
                <Button
                  size="large"
                  style={{
                  flex: 1,
                  height: 44,
                  borderRadius: 8,
                  fontWeight: 500,
                  background: "transparent",   
                  color: "#ff4d4f",             
                  border: "1px solid #ff4d4f", 
                  cursor: "default",
                }}
                >
                   Rejected
                </Button>
              ) : (
                // Show both Accept and Reject buttons
                <>
                  <Button
                    size="large"
                    onClick={onReject}
                    style={{
                      flex: 1,
                      height: 44,
                      borderRadius: 8,
                      fontWeight: 500,
                    }}
                  >
                    Reject
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    onClick={onAccept}
                    style={{
                      flex: 1,
                      height: 44,
                      borderRadius: 8,
                      fontWeight: 500,
                      background:
                        "linear-gradient(135deg, #1677ff 0%, #4096ff 50%, #69b1ff 100%)",
                      border: "none",
                    }}
                  >
                    Accept
                  </Button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EventModal;